import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../authConfig.js";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
// Sample app imports
import CustomerGeneralForm from "../components/Customer/CustomerGeneralForm";
import VendorRegisterForm from "../components/Customer/VendorRegisterForm";
import AgentRegisterForm from "../components/Customer/AgentRegisterForm";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";
import { useSearchParams } from "react-router-dom";
export function CustomerRegisterForm() {
  const authRequest = {
    ...loginRequest,
  };

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));

  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL: window.location.pathname,
    };
    fetch(api_path + "/GET_AUTHEN_URL.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          if (result["success"] == "0") {
            window.location = "/s-crm/Home?status=denined";
          }
        }
      });
  }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <Container maxWidth="md" className="BorderBox">
        <Grid container spacing={2}>
          <Grid container spacing={2}>
            <br />
          </Grid>
          {type == "1" && <CustomerGeneralForm CustomerID={type} />}
          {type == "2" && <AgentRegisterForm CustomerID={type} />}
          {type == "3" && <VendorRegisterForm CustomerID={type} />}
        </Grid>
      </Container>
    </MsalAuthenticationTemplate>
  );
}
